// extracted by mini-css-extract-plugin
module.exports = {"Button":"buttonStyles_Button__3PGXj"};